export default function(Vue){
    function queryString(str) {
        let params = str.split('?')[2]; //截取?号后的字符串即name=itclanCoder&study=css
        if(!params) return {}
        let param = params.split('&'); // 通过&符号进行分割即["name=itclanCoder", "study=css"]
        let obj = {}; // 用一个对象存储目标值
        for (let i = 0; i < param.length; i++) {
            // 循环遍历截取出来的param数组
            let paramsA = param[i].split('='); // 通过split,=继续对数组params每一项进行分割,生成数组["name", "itclanCoder"]
            let key = paramsA[0]; // 取数组项["name", "itclanCoder"]中第0位,即name
            let value = paramsA[1]; // 取数组项["name", "itclanCoder"]中第1位,即itclanCoder
            obj[key] = value;
        }
        return obj;
    }
    Vue.directive('viewButton', {
        // 当被绑定的元素插入到 DOM 中时……
        inserted: function (el) {
            console.log(queryString(encodeURIComponent(window.location.href)));
            let queryParams = queryString(window.location.href);
            // 聚焦元素
            // el.style.display = 'none'
            // console.log('this',this);
            if(queryParams.fetchOrigin){
                el.style.display = 'none'
            }
        }
    })
    Vue.directive('noTabIframe', {
        // 当被绑定的元素插入到 DOM 中时……
        inserted: function (el) {
            let queryParams = queryString(window.location.href);
            if(!queryParams.fetchOrigin){
                el.style.display = 'none'
            }
        }
    })
}